import React, { useRef, useState } from "react";
import Button from "../Button";

const ExcelUploadForm = ({ registeringAtBranch, company_id, onUpload }) => {
  const [excelFile, setExcelFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [ignoreErrors, setIgnoreErrors] = useState(false);
  const fileInputRef = useRef(null);

  const handleExcelFileUpload = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      console.log("file", file);
      setExcelFile(file);
    }
  };

  const handleUpload = () => {
    setIsUploading(true);
    onUpload(excelFile, ignoreErrors).finally(() => {
      setIsUploading(false);
    });
  };

  const handleEmailClick = (e) => {
    e.preventDefault();
    if (
      confirm(
        "This will email you the Excel template for the branch " +
          registeringAtBranch.name +
          " and put it in your 'Files' section of this system. Are you sure you want to continue?"
      )
    ) {
      window.location.href = e.target.href;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5F5F5",
        padding: 20,
        borderRadius: 8,
        maxWidth: 600,
        marginTop: 40,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <a
        href={`/registration/excel_registrations/download?branch_id=${
          registeringAtBranch.id
        }&company_id=${company_id}`}
        style={{ textAlign: "center" }}
        onClick={handleEmailClick}
      >
        <i className="fa fa-envelope" />
        &nbsp;&nbsp; Email me the Excel Template for branch {registeringAtBranch.name}
      </a>
      <div
        style={{
          marginBottom: 10,
          marginTop: 15,
          border: "1px solid #ccc",
          borderRadius: 4,
          padding: 15,
          backgroundColor: "#f9f9f9",
        }}
      >
        <label
          htmlFor="excel-upload"
          style={{
            display: "inline-block",
            padding: "8px 12px",
            backgroundColor: "white",
            color: "#45a049",
            borderRadius: 4,
            cursor: "pointer",
            transition: "background-color 0.3s",
            border: "1px solid #45a049",
            marginBottom: 0,
          }}
        >
          <i className="fa fa-file-excel-o" />
          &nbsp;&nbsp; Choose Excel File
        </label>
        <input
          id="excel-upload"
          type="file"
          accept=".xlsx,.xls"
          onChange={handleExcelFileUpload}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
        {excelFile && <span style={{ marginLeft: 10 }}>{excelFile.name}</span>}
        {!excelFile && <span style={{ marginLeft: 10 }}>No file selected</span>}
      </div>
      <div style={{ marginBottom: 10, marginTop: 7, textAlign: "center", width: "100%" }}>
        <label style={{ textAlign: "center", cursor: "pointer", fontWeight: "normal" }}>
          <input
            type="checkbox"
            checked={ignoreErrors}
            onChange={(e) => setIgnoreErrors(e.target.checked)}
            style={{ marginRight: 10, marginBottom: 0 }}
          />
          Ignore uploaded samples with errors and add the samples without errors?
        </label>
      </div>
      <Button
        title={isUploading ? "Uploading..." : "Upload Samples From Excel"}
        onClick={handleUpload}
        disabled={!excelFile || isUploading}
        icon={isUploading ? "fa-spinner fa-spin" : "fa-upload"}
        style={{
          backgroundColor: "#2196F3",
          color: "white",
          border: "none",
          padding: "10px 15px",
          borderRadius: 4,
          cursor: isUploading ? "not-allowed" : "pointer",
          transition: "background-color 0.3s",
          opacity: isUploading ? 0.7 : excelFile ? 1 : 0.7,
        }}
      />
    </div>
  );
};

export default ExcelUploadForm;
